// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2mPn8"};